import Confetti from "react-confetti"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router-dom"
import { useWindowSize } from "@react-hook/window-size"
import { observer } from "mobx-react-lite"
import { Header, Image, ScreenContainer, StyledButton, Text, Title, XIcon } from "../components"
import { ISuccessParams } from "../interfaces"
import { useRedirect } from "../utils"

const DEFAULT_IMAGE = null

export const SuccessPage = observer(() => {
	const navigate = useNavigate()
	const { state } = useLocation()
	const { t } = useTranslation()
	const [width, height] = useWindowSize()
	const success = state as ISuccessParams
	const { title, text, image: url, redirect } = success ?? { title: t("success.congratulations"), image: DEFAULT_IMAGE }

	useRedirect(redirect)

	const onClose = () => {
		if (redirect?.to) navigate(redirect.to)
		else navigate(-1)
	}

	return (
		<ScreenContainer>
			<div className="flex h-[90vh] w-full flex-col ">
				<Confetti width={width} height={height} recycle={false} numberOfPieces={300} tweenDuration={10000} />

				<Header
					right={
						<StyledButton onClick={onClose}>
							<XIcon />
						</StyledButton>
					}
				/>

				<div className="flex h-full w-full flex-col items-center justify-center ">
					<Title variant="h1">{title}</Title>
					{!!text && <Text style="mt-[5px] pb-[41px]">{text}</Text>}
					{url !== null && <Image url={url ?? null} width={300} height={300} />}
				</div>
			</div>
		</ScreenContainer>
	)
})
